import { classNames } from "@greeter/util";
import { IconArrowLeft } from "@tabler/icons-react";
import { HTMLMotionProps, motion } from "motion/react";
import { dropInOutFromBottom } from "@greeter/motion";
import { useEffect } from "react";
import useMeasure from "react-use-measure";
import { Card } from "@greeter/matter-v2";

import css from "./Toolbar.module.scss";

export type ToolbarProps = {
  title: string;
  onBack?: () => void;
} & HTMLMotionProps<"div">;

export function Toolbar({ className, layout, title, ...props }: ToolbarProps) {
  const [ref, { height }] = useMeasure();

  useEffect(() => {
    document.body.style.setProperty(
      "--bundlepicker-toolbar-height",
      `${height ?? 70}px`
    );
    return () =>
      void document.body.style.removeProperty("--bundlepicker-toolbar-height");
  }, [height]);

  return (
    <motion.div
      ref={ref}
      layout={layout ?? "position"}
      {...classNames(css.Toolbar, className)}
      {...props}
    >
      <div className={css.Content}>
        <Card
          style={{
            borderRadius: "var(--gm-border-radius-sm)",
            cursor: "pointer",
          }}
          onClick={props.onBack}
        >
          <Card.Content
            padding="sm"
            style={{ display: "grid", placeItems: "center" }}
          >
            <IconArrowLeft />
          </Card.Content>
        </Card>
        <motion.div {...dropInOutFromBottom} key={title}>
          {title}
        </motion.div>
        <div />
      </div>
    </motion.div>
  );
}

export function ToolbarContainer(props: HTMLMotionProps<"div">) {
  return (
    <motion.div
      style={{
        maxWidth: 600,
        margin: "auto",
        width: "100%",
        position: "sticky",
        top: 0,
        left: 0,
      }}
      {...props}
    />
  );
}

Toolbar.Container = ToolbarContainer;
